class PredictiveSearch extends HTMLElement {
    constructor () {
        super()

        this.form = this.querySelector('form')
        this.input = this.querySelector('input[type="search"]')
        this.results = this.querySelector('#predictive-search')
        this.alert = this.querySelector('#predictive-search-alert')
        this.footer = this.closest('#offcanvas-search')?.querySelector('.offcanvas-footer')
        this.popularProducts = this.closest('#offcanvas-search')?.querySelector('#search-popular-products-wrapper')
        this.speechBtn = this.querySelector('.btn-search-by-voice')
        
        this.searchIcon = this.querySelector('.icon-search')

        if (this.searchIcon && this.form) {
            this.searchIcon.style.cursor = 'pointer';
            this.searchIcon.addEventListener('click', () => {
                const searchTerm = this.input.value.trim();
                if (searchTerm.length > 0) {
                    this.form.submit();
                }
            });
        }

        if (this.input && this.form) {
            this.input.addEventListener('keydown', (e) => {
                if (e.key === 'Enter') {
                    e.preventDefault();
                    const searchTerm = this.input.value.trim();
                    if (searchTerm.length > 0) {
                        this.form.submit();
                    }
                }
            });
        }

        this.input.addEventListener('input', this.debounce((event) => {
            this.onChange()
        }, 300).bind(this))

        document.querySelector('#offcanvas-search')?.addEventListener('shown.bs.offcanvas', () => {
            this.input.focus()
        })

        if (window.SpeechRecognition || window.webkitSpeechRecognition) {
            this.speechBtn?.addEventListener('click', () => {
                this.speechRecognition()
            })
        } else {
            this.speechBtn?.remove()
        }

        document.querySelectorAll('#offcanvas-search .btn-atc').forEach(btn => {
            btn.addEventListener('click', () => {
                setTimeout(() => {
                    bootstrap.Offcanvas.getOrCreateInstance('#offcanvas-search').hide()
                }, 300)
            })
        })
    }

    onChange () {
        const searchTerm = this.input.value.trim()

        if (this.footer) {
            const qInput = this.footer.querySelector('[name="q"]');
            const btn = this.footer.querySelector('.btn');
            
            if (qInput) qInput.value = searchTerm;
            if (btn && btn.dataset.textSearchFor) {
                btn.textContent = `${btn.dataset.textSearchFor} "${searchTerm}"`;
            }
        }

        if (!searchTerm.length) {
            this.close()
            return
        }

        this.getSearchResults(searchTerm)
    }

    async getSearchResults (searchTerm) {
        let resourcesTypes = ['product']

        if (this.input.dataset.searchCollections === 'true') resourcesTypes.push('collection');
        if (this.input.dataset.searchPages === 'true') resourcesTypes.push('page');
        if (this.input.dataset.searchArticles === 'true') resourcesTypes.push('article');
        
        const resourcesType = resourcesTypes.join(',');

        try {
            // ❶ جلب المسار من النموذج (يحتوي تلقائياً على بادئة اللغة مثل /ar/search أو /search)
            let actionUrl = this.form ? this.form.getAttribute('action') : '/search';
            if (!actionUrl || actionUrl === '') actionUrl = '/search';
            
            // تنظيف المسار لضمان عدم وجود شرطات زائدة
            actionUrl = actionUrl.replace(/\/\//g, '/').replace(/\/$/, '');
            const suggestEndpoint = actionUrl + '/suggest';
            
            // ❷ استخدام URLSearchParams وهو الأداة الأقوى لتشفير الحروف العربية ومنع كسر الرابط
            const queryParams = new URLSearchParams({
                q: searchTerm,
                'resources[type]': resourcesType,
                'resources[limit]': 10,
                'section_id': 'predictive-search',
                'options[prefix]': 'last'
            });

            const finalUrl = `${suggestEndpoint}?${queryParams.toString()}`;

            // ❸ إرسال الطلب بشكل مبسط جداً (بدون Headers مخصصة) لتجنب حظر الخادم (CORS)
            const response = await fetch(finalUrl);

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const text = await response.text();
            
            const parser = new DOMParser();
            const doc = parser.parseFromString(text, 'text/html');
            
            // ❹ البحث عن القسم المحدث داخل الرد
            const predictiveSection = doc.querySelector('#shopify-section-predictive-search') || doc.querySelector('#predictive-search-results');

            if (predictiveSection && predictiveSection.innerHTML.trim().length > 0) {
                this.results.innerHTML = predictiveSection.innerHTML;
                this.open();
            } else {
                // إذا لم توجد نتائج، لا تغلق النافذة بل افتحها لتظهر عبارة (لم يتم العثور على نتائج)
                this.results.innerHTML = '';
                this.open();
            }
        } catch (error) {
            console.error('Search Fetch Error:', error);
            this.results.innerHTML = '';
            this.open(); // إظهار رسالة عدم العثور بدلاً من توقف النافذة بصمت
        }
    }

    open () {
        this.results.style.display = 'block'

        const countResults = this.results.querySelectorAll('.product-item').length

        if (this.alert) {
            switch (countResults) {
            case 0:
                this.alert.textContent = this.alert.dataset.textNoResults || 'No results found';
                break
            case 1:
                this.alert.textContent = this.alert.dataset.textResultFound || '1 result found';
                break
            default:
                if (this.alert.dataset.textResultsFound) {
                    this.alert.textContent = this.alert.dataset.textResultsFound.replace('[count]', countResults);
                }
                break
            }
        }

        this.footer?.removeAttribute('hidden')
        window.SPR?.initDomEls?.()
        window.SPR?.loadBadges?.()
        this.popularProducts?.setAttribute('hidden', 'hidden')
    }

    close () {
        if (this.results) this.results.style.display = 'none';
        if (this.alert) this.alert.textContent = '';
        this.footer?.setAttribute('hidden', 'hidden')
        this.popularProducts?.removeAttribute('hidden')
    }

    speechRecognition () {
        var SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition
        if (!SpeechRecognition) return;

        const recognition = new SpeechRecognition()

        recognition.onstart = () => {
            this.speechBtn?.classList.add('speech-started')
            setTimeout(() => {
                this.speechBtn?.classList.remove('speech-started')
            }, 5000)
        }

        recognition.onspeechend = (event) => {
            this.speechBtn?.classList.remove('speech-started')
        }

        recognition.onresult = (event) => {
            if (event.results) {
                this.input.value = event.results[0][0].transcript
                this.onChange()
            }
        }

        recognition.start()
    }

    debounce (fn, wait) {
        let t
        return (...args) => {
            clearTimeout(t)
            t = setTimeout(() => fn.apply(this, args), wait)
        }
    }
}

if (!customElements.get('predictive-search')) {
    customElements.define('predictive-search', PredictiveSearch)
}

window.closeSearchOffcanvas = (btn, event) => {
    setTimeout(() => {
        const offcanvasEl = document.querySelector('#offcanvas-search');
        if (offcanvasEl && typeof bootstrap !== 'undefined') {
            bootstrap.Offcanvas.getOrCreateInstance(offcanvasEl).hide();
        }
    }, 300)
}